import * as React from 'react';
import * as _ from 'underscore';
import * as $ from 'jquery';

import SelectField from '../../../_common/platform/tsx/SelectField';
import NumberField from '../../../_common/platform/tsx/NumberField';

require('../sass-main/pdc-widget-cards2.sass');
declare var require: any;

export class LayoutTheme extends React.Component<
    {
        value?: any;
        allowNull?: boolean;
        title?: string;

        options?: {
            title?: string;
            allowNull?: boolean;
        };
        disabled?: boolean;
        readOnly?: boolean;

        onChange?(value: any): void;
    },
    {
        value: {
            layout: string;
            size: string;
            height: number;
            width: number;
            count: number;
        };
        scheme: string;
    }
> {
    private static DEFAULT_SCHEME = 'dark';

    constructor(props) {
        super(props);
        var value = this.props.value;
        this.state = {
            value: value,
            scheme: LayoutTheme.DEFAULT_SCHEME
        };
    }
    componentDidMount() {
        this.setScheme();
    }

    setScheme = () => {
        //if (this.state.scheme !== scheme)
        {
            const state = this.state;
            //  state.scheme = scheme;
            this.setState(state);
        }
    };

    componentWillReceiveProps(newProps) {
        const newValue = newProps.value;
        if (newValue !== this.props.value) {
            this.setState({ value: newValue });
        }
    }

    onChangeHeight = (val) => {
        var value = {
            layout: _.clone(this.state.value.layout),
            size: _.clone(this.state.value.size),
            height: val,
            width: _.clone(this.state.value.width),
            count: _.clone(this.state.value.count)
        };
        this.setState(
            _.extend(this.state, {
                value: value
            })
        );
        if (typeof this.props.onChange === 'function') {
            this.props.onChange(value);
        }
    };

    onChangeWidth = (val) => {
        var value = {
            layout: _.clone(this.state.value.layout),
            size: _.clone(this.state.value.size),
            height: _.clone(this.state.value.height),
            width: val,
            count: _.clone(this.state.value.count)
        };
        this.setState(
            _.extend(this.state, {
                value: value
            })
        );
        if (typeof this.props.onChange === 'function') {
            this.props.onChange(value);
        }
    };
    onChangeCount = (val) => {
        var value = {
            layout: _.clone(this.state.value.layout),
            size: _.clone(this.state.value.size),
            height: _.clone(this.state.value.height),
            width: _.clone(this.state.value.width),
            count: val
        };
        this.setState(
            _.extend(this.state, {
                value: value
            })
        );
        if (typeof this.props.onChange === 'function') {
            this.props.onChange(value);
        }
    };
    handleLayoutChange = (val) => {
        var value = {
            layout: val,
            size: _.clone(this.state.value.size),
            height: _.clone(this.state.value.height),
            width: _.clone(this.state.value.width),
            count: _.clone(this.state.value.count)
        };
        this.setState(
            _.extend(this.state, {
                value: value
            })
        );
        if (typeof this.props.onChange === 'function') {
            this.props.onChange(value);
        }
    };

    handleSizeChange = (val) => {
        var value = {
            layout: _.clone(this.state.value.layout),
            size: val,
            height: _.clone(this.state.value.height),
            width: _.clone(this.state.value.width),
            count: _.clone(this.state.value.count)
        };
        this.setState(
            _.extend(this.state, {
                value: value
            })
        );
        if (typeof this.props.onChange === 'function') {
            this.props.onChange(value);
        }
    };

    render() {
        var sizeType = {
            values: ['flow', 'fixed', 'even'],
            display: ['Flow', 'Fixed', 'Occupy entire widget']
        };

        var className = 'visible margin';
        var classNameCount = 'visible';
        var disabled = false;

        if (this.state.value.layout == 'byRow') {
            sizeType = {
                values: ['flow', 'fixed'],
                display: ['Flow', 'Fixed']
            };
        }
        if (this.state.value.layout == 'flow') {
            classNameCount = 'invisible';
            //this.state.value.size = 'fixed'
            sizeType = {
                values: ['auto', 'fixed'],
                display: ['Auto', 'Fixed']
            };
        }

        if (this.state.value.size == 'flow' || this.state.value.size == 'even' || this.state.value.size == 'auto') {
            className = 'invisible';
        }

        var layoutType = {
            values: ['byCol', 'byRow', 'flow'],
            display: ['By Column', 'By Row', 'Flow']
        };
        var layoutValue = this.state.value.layout;
        var sizeValue = this.state.value.size;

        return (
            <div className="pdc-widget-cards-config" style={{ display: 'table' }}>
                <div style={{ display: 'table-row' }}>
                    <div className="margin" style={{ float: 'left' }}>
                        <b>Layout</b>
                        <div style={{ paddingTop: '5px' }}>
                            <SelectField value={layoutValue} options={layoutType} onChange={this.handleLayoutChange} />
                        </div>
                    </div>
                </div>
                <div style={{ display: 'table-row' }}>
                    <div className={'margin ' + classNameCount} style={{ float: 'left' }}>
                        <b>Count</b>
                        <div style={{ paddingTop: '5px' }}>
                            <NumberField value={this.state.value.count} integer={true} onChange={this.onChangeCount} />
                        </div>
                    </div>
                </div>
                <div style={{ display: 'table-row' }}>
                    <div className="" style={{ float: 'left' }}>
                        <b>Size</b>
                        <div style={{ paddingTop: '5px' }}>
                            <SelectField
                                disabled={disabled}
                                value={sizeValue}
                                options={sizeType}
                                onChange={this.handleSizeChange}
                            />
                        </div>
                    </div>
                    <div className={className} style={{ float: 'left' }}>
                        <b>Height</b>
                        <div style={{ paddingTop: '5px' }}>
                            <NumberField
                                value={this.state.value.height}
                                integer={true}
                                onChange={this.onChangeHeight}
                            />
                        </div>
                    </div>
                    <div className={className} style={{ float: 'left' }}>
                        <b>Width</b>
                        <div style={{ paddingTop: '5px' }}>
                            <NumberField value={this.state.value.width} integer={true} onChange={this.onChangeWidth} />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
